import React from "react";
import moment from "moment";
import { Collapse, List, type CollapseProps } from "antd";
import { useThemeContext } from "../../../context/ThemeContext";
import { useGetAssignedAddonsQuery } from "../../../redux/services/settingsApi";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import GradientButton from "../../../components/common/UI/GradientButton";
import CustomLoader from "../../../components/common/UI/Loader";
import "./index.scss";

interface AssignAddonsProps {
  handleBackToPrevious: () => void;
}

const AssignAddons: React.FC<AssignAddonsProps> = ({
  handleBackToPrevious,
}) => {
  const { theme } = useThemeContext();
  const { data: addonsData, isLoading } = useGetAssignedAddonsQuery();

  const customHeader = (title: string, end: any) => (
    <div className="custom-header">
      <GradientButton className="option-icon">
        <img
          src={`/assets/icons/${theme}/subscription.png`}
          width={20}
          height={20}
          alt="ring"
        />
      </GradientButton>
      <span>{title}</span>
      <span className="end-text">{end}</span>
    </div>
  );

  const collapseItems: CollapseProps["items"] = [
    {
      key: "1",
      label: customHeader("Assign Addons", ""),
      showArrow: false,
      children: (
        <div className="addons-container">
          <List
            key="call-addons"
            className="assign-addons-list"
            dataSource={addonsData?.data?.getAllAddons || []}
            loading={{
              spinning: isLoading,
              indicator: <CustomLoader />,
            }}
            renderItem={(item: any) => (
              <List.Item className="addon-item">
                <div>
                  <h5 className="addon-title">
                    {item.addonName}{" "}
                    {/* <span
                      style={{
                        color: item.status === "active" ? "green" : "red",
                        textTransform: "capitalize",
                        fontSize: "14px",
                      }}
                    >
                      {item.status}
                    </span> */}
                  </h5>
                  <p className="addon-cost">{item.addonCost}$ Monthly</p>
                  <p className="addon-description">
                    Next billing date:{" "}
                    {moment(
                      addonsData?.data.billingDetails?.next_billing_at
                    ).format("DD MMMM YYYY")}
                  </p>
                </div>
              </List.Item>
            )}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="assign-addons-wrapper">
      <SettingsSidebarHeader
        title="Assign Addons"
        handleBackClick={handleBackToPrevious}
      />

      <div className="assign-addons-container">
        <Collapse
          expandIconPosition="end"
          className="custom-collapse"
          defaultActiveKey={["1"]}
          activeKey={["1"]}
          items={collapseItems}
        />
      </div>
    </div>
  );
};

export default AssignAddons;
